<div class="history-dialog">

    <!-- Header -->
    <div class="history-dialog__header">
        <div class="history-dialog__header-left">
            <div class="history-dialog__icon-wrap">
                <mat-icon>history</mat-icon>
            </div>
            <div>
                <h2 class="history-dialog__title">Istoric acțiuni</h2>
                <p class="history-dialog__subject" *ngIf="data.subject">{{ data.subject }}</p>
            </div>
        </div>
        <button class="history-dialog__close" (click)="closeDialog()" type="button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Body -->
    <div class="history-dialog__body">

        <!-- Empty state -->
        <div class="history-dialog__empty" *ngIf="!data.action_history || data.action_history.length === 0">
            <mat-icon>inbox</mat-icon>
            <p>Nu există acțiuni înregistrate pentru acest email.</p>
        </div>

        <!-- Timeline -->
        <div class="history-timeline" *ngIf="data.action_history && data.action_history.length > 0">

            <div class="history-timeline__count">
                {{ data.action_history.length }} acțiun{{ data.action_history.length === 1 ? 'e' : 'i' }} înregistrate
            </div>

            <div class="history-timeline__items">
                <div class="timeline-item" *ngFor="let entry of data.action_history; let i = index; let last = last"
                    [class.timeline-item--last]="last">

                    <!-- Line connector -->
                    <div class="timeline-item__line" *ngIf="!last"></div>

                    <!-- Icon node -->
                    <div class="timeline-item__node" [ngClass]="getActionClass(entry.content)">
                        <mat-icon>{{ getActionIcon(entry.content) }}</mat-icon>
                    </div>

                    <!-- Content card -->
                    <div class="timeline-item__card">
                        <div class="timeline-item__card-header">
                            <span class="timeline-item__content">{{ entry.content }}</span>
                            <span class="timeline-item__index">#{{ data.action_history.length - i }}</span>
                        </div>
                        <div class="timeline-item__meta">
                            <span class="timeline-item__user">
                                <mat-icon>person</mat-icon>
                                {{ entry.user_name }}
                            </span>
                            <span class="timeline-item__separator">·</span>
                            <span class="timeline-item__date">
                                <mat-icon>schedule</mat-icon>
                                {{ entry.created_at | date: 'dd.MM.yyyy HH:mm:ss' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="history-dialog__footer">
        <button class="hd-btn hd-btn--ghost" type="button" mat-flat-button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
            Închide
        </button>
    </div>

</div>